import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import styles from './Error.module.scss'

export const Error = ({ children }) => (
  <Fragment>{children ? <div className={styles.component}>{children}</div> : null}</Fragment>
)

Error.propTypes = {
  children: PropTypes.node,
}
